<template>
  <!-- 广告图设置 -->
  <div class="advertList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商城管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增广告图</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="分类状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="已启用" value="2"></el-option>
          <el-option label="已禁用" value="1"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" align="center" type="index" width="150">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="广告图编号"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        align="center"
        show-overflow-tooltip
        label="广告图名称"
      >
      </el-table-column>
      <el-table-column
        prop="pcLink"
        label="PC跳转链接"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="APP跳转类型"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          appTypeData[scope.row.name]
        }}</template>
      </el-table-column>
      <el-table-column
        prop="appName"
        label="APP跳转内容"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">已禁用</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已启用</el-tag>
          <el-tag type="info" v-if="scope.row.status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status != 0"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-show="scope.row.status == 1"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 2)"
            >启用</el-button
          >
          <el-button
            v-show="scope.row.status == 2"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 1)"
            >禁用</el-button
          >
          <!-- <el-button
            v-show="scope.row.status != 0"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 0)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 编辑广告图 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑广告图</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="addFormRule"
            ref="addForm"
          >
            <!-- <el-form-item label="选择级别" prop="rank">
              <el-select v-model="addForm.rank" placeholder="请选择" style="width:100%" @change="setSortRank">
                <el-option label="一级分类" value="1"></el-option>
                <el-option label="二级分类" value="2"></el-option>
                <el-option label="三级分类" value="3"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item
              v-show="addForm.rank == '2'"
              label="选择父级分类"
              prop="parentId"
            >
              <el-select
                v-model="addForm.parentId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in tableData"
                  :key="index"
                  :label="item.title"
                  :value="item.id + ''"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="addForm.rank == '3'"
              label="选择父级分类"
              prop="parentId"
            >
              <el-select
                v-model="addForm.parentId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in twoList"
                  :key="index"
                  :label="item.title"
                  :value="item.id + ''"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="广告图名称" prop="title">
              <el-input v-model="addForm.title"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="icon">
              <upload
                @fileChange="uploadSortImg"
                accept="image/jpg,image/jpeg,image/png"
                :multiple="true"
              ></upload>
              <img-view
                style="margin-left: 20px"
                :imgList="[{ url: sortImg, id: 0 }]"
              ></img-view>
              <div>250px*350px，按照该比例设置即可</div>
            </el-form-item>
            <!-- <el-form-item v-show="addForm.rank == '1'" label="跳转路径" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item> -->
            <el-form-item label="PC跳转链接" prop="pcLink">
              <el-input v-model="addForm.pcLink"></el-input>
            </el-form-item>
            <el-form-item label="APP跳转类型" prop="appType">
              <el-select
                v-model="addForm.appType"
                placeholder="跳转类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in $store.state.APP_TYPE_LIST"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="商品编号"
              prop="appGoods"
              v-show="addForm.appType == '1'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appGoods"
                clearable
                placeholder="商品编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="跳转模块"
              prop="appMode"
              v-if="addForm.appType == '2'"
              class="el-form-required-true"
            >
              <el-select
                v-model="addForm.appMode"
                placeholder="跳转模块"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in appModeList"
                  :key="item.Id"
                  :label="item.title"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="网页链接"
              prop="appWebUrl"
              v-show="addForm.appType == '3'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appWebUrl"
                clearable
                placeholder="网页链接"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="商品分类"
              prop="appGoodsSort"
              v-show="addForm.appType == '4'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appGoodsSortName"
                placeholder="单击选择"
                readonly
                @click.native="getGoodsSort('')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="专区列表"
              prop="appMode"
              v-if="addForm.appType == '5'"
              class="el-form-required-true"
            >
              <el-select
                v-model="addForm.appExpert"
                placeholder="专区列表"
                style="width: 100%"
              >
                <el-option
                  v-for="item in appExpertList"
                  :key="item.Id"
                  :label="item.title"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                style="width: 100%"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
    <!-- 数据选择 -->
    <tableDialog
      v-if="goodsSort.isShow"
      title="商品分类(二级分类)"
      :tableData="goodsSort.tableData"
      :tableHead="goodsSort.tableDataHead"
      :currPage.sync="goodsSort.currPage"
      :allPage="goodsSort.allPage"
      @search="getGoodsSort"
      @rowClick="goodsSortSel"
      @hanCurrChange="goodsSortPage"
      @close="goodsSort.isShow = false"
    ></tableDialog>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护APP、PC首页开屏广告，在首次首页打开时，会向用户展示</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "advertList",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        status: "9",
      },
      // 二级分类列表
      twoList: [],
      appTypeData: {
        0: "无跳转",
        1: "商品详情",
        2: "跳转模块",
        3: "网页链接",
        4: "商品分类",
        5: "专区商品",
      },
      appModeList: [], // 模块列表
      appModeData: {}, // 模块数据
      goodsSortData: {}, // 分类数据
      appExpertList: [], // 专区列表
      appExpertData: {}, // 专区数据
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: 0,
        title: "",
        rank: "1",
        sort: 1,
        status: 2,
        channelId: 1,
        parentId: "0",
        name: "",
        icon: "",
        navType: "AdvertList",
        pcLink: "",
        appType: "0",
        appGoods: "",
        appMode: "",
        appWebUrl: "",
        appGoodsSort: "",
        appGoodsSortName: "",
        appExpert: "",
        appName: "",
      },
      sortImg: "", // 分类图片，用于本地显示
      addFormRule: {
        rank: [mustFill],
        parentId: [mustFill],
        title: [mustFill],
        icon: [mustFill],
        sort: [mustFill],
        appType: [mustFill], // 移动端跳转类型
        appGoods: [this.appLinkFill("appType", "1")], // 移动端商品编号
        appMode: [this.appLinkFill("appType", "2")], // 移动端跳转模块
        appWebUrl: [this.appLinkFill("appType", "3")], // 移动端跳转网页
        appGoodsSort: [this.appLinkFill("appType", "4")], // 移动端商品分类
        appExpert: [this.appLinkFill("appType", "5")], // 移动端专区编号
      },
      goodsSort: {
        isShow: false,
        name: "",
        tableData: [],
        tableDataHead: {},
        currPage: 1,
        allPage: 1,
      },

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getMode();
  },
  methods: {
    updata() {
      this.getMode();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        navType: "AdvertList",
        status: this.searchForm.status,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.changeArr(res.list || []);
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**递归调用函数 */
    changeArr(list) {
      let obj = {};
      obj[0] = [];
      let twoList = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let itemData = this.setTabelItem(item);
        if (item.rank == 1) {
          obj[0].push(itemData);
        } else {
          if (!obj[item.parent_id]) {
            obj[item.parent_id] = [];
          }
          if (item.rank == 2) {
            twoList.push(itemData);
          }
          obj[item.parent_id].push(itemData);
        }
      }
      for (let i = 0; i < obj[0].length; i++) {
        obj[0][i].childs = obj[obj[0][i].id];
        delete obj[obj[0][i].id];
      }
      for (let i = 0; i < twoList.length; i++) {
        twoList[i].childs = obj[twoList[i].id];
      }
      this.allPage = obj[0].length;
      this.tableData = obj[0];
      this.twoList = twoList;
    },
    // 设置表格数据格式
    setTabelItem(item) {
      let appName = "无";
      if (item.name == 1 || item.name == 3) {
        appName = item.link_url || "无";
      } else if (item.name == 2) {
        appName =
          (this.appModeData[item.link_url] &&
            this.appModeData[item.link_url].title) ||
          "无";
      } else if (item.name == 4) {
        appName =
          (this.goodsSortData[item.link_url] &&
            this.goodsSortData[item.link_url]["分类"]) ||
          "无";
      } else if (item.name == 5) {
        appName =
          (this.appExpertData[item.link_url] &&
            this.appExpertData[item.link_url].title) ||
          "无";
      }
      return {
        id: item.Id,
        title: item.title,
        rank: item.rank + "",
        sort: item.sort_id,
        status: item.status,
        channelId: item.channel_id,
        parentId: item.parent_id + "",
        name: item.name,
        pcLink: item.url,
        appType: item.name,
        appGoods: item.name == 1 ? item.link_url : "",
        appMode: item.name == 2 ? item.link_url : "",
        appWebUrl: item.name == 3 ? item.link_url : "",
        appGoodsSort: item.name == 4 ? item.link_url : "",
        appGoodsSortName: item.name == 4 ? appName : "",
        appExpert: item.name == 5 ? item.link_url : "",
        appName: appName,
        icon: item.icon_url,
        navType: item.nav_type,
        childs: [],
      };
    },
    // 获取可跳转模块
    getMode() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        navType: "APPLink",
        status: 2,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "Post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.appModeList = res.list || [];
            this.appModeData = this.$arrToObj(this.appModeList, "name");
          }
          this.getGoodsSortAll();
        })
        .catch((err) => {
          window.console.log(err);
          this.getGoodsSortAll();
        });
    },
    // 获取所有商品分类
    getGoodsSortAll() {
      let data = {
        type: "CategrysListHG",
        PageIndex: 1,
        PageSize: 10000,
        strWhere: "",
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      let url =
        "ashx/MainReturnJson.ashx?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&type=" +
        type +
        "&proc=" +
        proc;
      this.$requestSys({
        method: "post",
        url: url,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsSortData = this.$arrToObj(res.content || [], "keyid");
          }
          this.getExpert();
        })
        .catch((err) => {
          window.console.log(err);
          this.getExpert();
        });
    },
    // 获取专区列表
    getExpert() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        navType: "ExpertList",
        status: 2,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "Post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.appExpertList = res.list || [];
            this.appExpertData = this.$arrToObj(this.appExpertList, "name");
          }
          this.getTableData();
        })
        .catch((err) => {
          window.console.log(err);
          this.getTableData();
        });
    },
    // 移动端跳转链接控制验证
    appLinkFill(key, keyValue) {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm[key] == keyValue) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    // 获取商品分类
    getGoodsSort(val, isRep) {
      this.goodsSort.name = isRep ? val : this.goodsSort.name;
      this.goodsSort.currPage = isRep ? 1 : this.goodsSort.currPage;
      let data = {
        type: "CategrysListHG",
        PageIndex: this.goodsSort.currPage,
        PageSize: 10,
        strWhere: this.goodsSort.name,
      };
      let proc = "Proc_Admin_SearchInfo"; // 存储过程名
      let type = "ReturnDataSet";
      let url =
        "ashx/MainReturnJson.ashx?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&type=" +
        type +
        "&proc=" +
        proc;
      this.$requestSys({
        method: "post",
        url: url,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsSort.isShow = true;
            this.goodsSort.tableData = res.content;
            this.goodsSort.tableDataHead = res.fdname;
            this.goodsSort.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    goodsSortPage(val) {
      this.goodsSort.currPage = val;
      this.getGoodsSort();
    },
    // 商品分类选择完成
    goodsSortSel(row) {
      this.addForm.appGoodsSort = row.keyid;
      this.addForm.appGoodsSortName = row["分类"];
      this.goodsSort.isShow = false;
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**删除角色 */
    handleDel() {
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        let row = this.selectedList[0];
        this.handleStatus(row, 0);
        // })
        // .catch(() => {});
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    /**更改状态 */
    handleStatus(row, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 0) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            id: row.id,
            status: status,
          };
          this.$request({
            url: "Navigation/UpdateNavigationStatusDal",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (let key in this.addForm) {
          this.addForm[key] = row[key];
        }
        this.sortImg = this.$setImgUrl(row.icon);
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        id: 0,
        title: "",
        rank: "1",
        sort: 1,
        status: 2,
        channelId: 1,
        parentId: "0",
        name: "",
        icon: "",
        navType: "AdvertList",
        pcLink: "",
        appType: "0",
        appGoods: "",
        appMode: "",
        appWebUrl: "",
        appGoodsSort: "",
        appGoodsSortName: "",
        appExpert: "",
        appName: "",
      };
      this.sortImg = "";
      this.addDrawer = false;
    },
    // 设置分类等级
    setSortRank() {
      if (this.addForm.rank == 2) {
        this.addForm.parentId = this.tableData[0].id + "";
      } else if (this.addForm.rank == 3) {
        this.addForm.parentId = this.twoList[0].id + "";
      }
    },
    // 上传分类图片
    uploadSortImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.addForm.icon = res.message;
              this.sortImg = this.$setImgUrl(res.message);
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let link = "";
          if (this.addForm.appType == "1") {
            link = this.addForm.appGoods;
          } else if (this.addForm.appType == "2") {
            link = this.addForm.appMode;
          } else if (this.addForm.appType == "3") {
            link = this.addForm.appWebUrl;
          } else if (this.addForm.appType == "4") {
            link = this.addForm.appGoodsSort;
          } else if (this.addForm.appType == "5") {
            link = this.addForm.appExpert;
          }
          let data = {
            entId: window.localStorage.getItem("entId"),
            Id: this.addForm.id,
            channel_id: this.addForm.channelId,
            icon_url: this.addForm.icon,
            nav_type: this.addForm.navType,
            name: this.addForm.appType,
            link_url: link,
            parent_id: this.addForm.parentId,
            rank: this.addForm.rank,
            sort_id: this.addForm.sort,
            status: this.addForm.status,
            title: this.addForm.title,
            url: this.addForm.pcLink,
          };
          this.$request({
            url: "Navigation/EditNavigation",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.advertList {
  width: 100%;
  height: 100%;
}
</style>
